import { FC } from 'react';

import { NEWBUILDING_MONTHLY_PAYMENT } from 'shared/constants/experiments';
import { useExperiment } from 'shared/hooks/useExperiment';
import { MortgageSearchTypeContainer } from './inner/MortageSearchTypeContainer';
import { useRuntimeSetting } from 'shared/hooks/useRuntimeSetting';

export const MortgageProgramSearchTypeContainer: FC = () => {
  const isNewBuildingMonthlyPaymentExperimentEnabled = useExperiment(NEWBUILDING_MONTHLY_PAYMENT);
  const isEnabled = useRuntimeSetting('Newbuilding.MortgageMonthlyPayment.Enabled', false);

  if (!isNewBuildingMonthlyPaymentExperimentEnabled || !isEnabled) {
    return null;
  }

  return <MortgageSearchTypeContainer isNew={true} title="Программа" allowMultiple={false} />;
};
